import { useMutation } from '@tanstack/react-query'

import { updateControlPortMeasure } from '@/features/resource/endpoints/resources'

export function useUpdateControlPortMeasureMutation() {
  const { mutateAsync, ...mutationResult } = useMutation({
    mutationFn: (variables: { resourceId: string; controlPortId: string; measure: string }) =>
      updateControlPortMeasure(variables.resourceId, variables.controlPortId, variables.measure),
  })

  return {
    updateControlPortMeasure: mutateAsync,
    ...mutationResult,
  }
}
